import { restClient } from '../config/restClient'

const endpoint = hiringTeamId => `/api/company/v2/hiring_teams/${hiringTeamId}/candidate_notes`

export const getCandidateNotes = async (hiringTeamId, params) => {
  const response = await restClient(endpoint(hiringTeamId), {
    method: 'GET',
    params,
  })

  return response.data
}

export const postCandidateNote = async (hiringTeamId, data) => {
  const response = await restClient(endpoint(hiringTeamId), {
    method: 'POST',
    data,
  })

  return response.data
}

export const patchCandidateNote = async (hiringTeamId, noteId, data) => {
  const response = await restClient(`${endpoint(hiringTeamId)}/${noteId}`, {
    method: 'PATCH',
    data,
  })

  return response.data
}

export const deleteCandidateNote = async (hiringTeamId, id) => {
  const response = await restClient(`${endpoint(hiringTeamId)}/${id}`, {
    method: 'DELETE',
  })

  return response.data
}
